module.exports = __webpack_public_path__ + "assets/img/gal_10.5c0a453c.jpg";